<div class="app-container">
  <app-header *ngIf="showHeaderFooter" class="fixed-header"></app-header>
  <div *ngIf="showHeaderFooter" id="header-gap"></div>
  <router-outlet></router-outlet>
  <div *ngIf="showHeaderFooter" id="footer-gap"></div>
  <app-footer *ngIf="showHeaderFooter" class="fixed-footer"></app-footer>
  <app-global-modal></app-global-modal>
  <app-global-notifications></app-global-notifications>
  <app-login-prompt></app-login-prompt>
</div>
